export default __webpack_public_path__ + "static/media/WorkingOut-hover.61e87db7.svg";